import { Descriptions } from "antd";
// Detalle para artículo de Supermercado
export const CDetalleArticuloSupermercado = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Contenido Neto" span={2}>{detalle.contenido_neto || '—'}</Descriptions.Item>
      <Descriptions.Item label="Unidad de Medida" span={2}>{detalle.ums_nombre || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo de Indumentaria
export const CDetalleArticuloIndumentaria = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Talle" span={2}>{detalle.talle || '—'}</Descriptions.Item>
      <Descriptions.Item label="Color" span={2}>{detalle.color || '—'}</Descriptions.Item>
      <Descriptions.Item label="Género" span={2}>{detalle.genero || '—'}</Descriptions.Item>
      <Descriptions.Item label="Temporada" span={2}>{detalle.temporada || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo de Electrónica
export const CDetalleArticuloElectronica = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Marca" span={2}>{detalle.marca_modelo || '—'}</Descriptions.Item>
      <Descriptions.Item label="Modelo" span={2}>{detalle.modelo || '—'}</Descriptions.Item>
      <Descriptions.Item label="Voltaje" span={2}>{detalle.voltaje || '—'}</Descriptions.Item>
      <Descriptions.Item label="Tipo de Batería" span={2}>{detalle.tipo_bateria || '—'}</Descriptions.Item>
      <Descriptions.Item label="Conectividad" span={2}>{detalle.conectividad || '—'}</Descriptions.Item>
      <Descriptions.Item label="Garantía" span={2}>{detalle.garantia || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo de Electrodoméstico
export const CDetalleArticuloElectrodomestico = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Consumo de Energía" span={2}>{detalle.consumo_energia || '—'}</Descriptions.Item>
      <Descriptions.Item label="Eficiencia Energética" span={2}>{detalle.eficiencia_energetica || '—'}</Descriptions.Item>
      <Descriptions.Item label="Capacidad" span={2}>{detalle.capacidad || '—'}</Descriptions.Item>
      <Descriptions.Item label="Unidad de Capacidad" span={2}>{detalle.unidad_capacidad || '—'}</Descriptions.Item>
      <Descriptions.Item label="Voltaje" span={2}>{detalle.voltaje || '—'}</Descriptions.Item>
      <Descriptions.Item label="Dimensiones" span={2}>{detalle.dimensiones || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo de Mueble
export const CDetalleArticuloMueble = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Material" span={2}>{detalle.material || '—'}</Descriptions.Item>
      <Descriptions.Item label="Dimensiones" span={2}>{detalle.dimensiones || '—'}</Descriptions.Item>
      <Descriptions.Item label="Tipo de Mueble" span={2}>{detalle.tipo_mueble || '—'}</Descriptions.Item>
      <Descriptions.Item label="Color" span={2}>{detalle.color || '—'}</Descriptions.Item>
      <Descriptions.Item label="Peso Soportado" span={2}>{detalle.peso_soportado || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo de Juguete
export const CDetalleArticuloJuguete = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Edad Recomendada" span={2}>{detalle.edad_recomendada || '—'}</Descriptions.Item>
      <Descriptions.Item label="Material" span={2}>{detalle.material || '—'}</Descriptions.Item>
      <Descriptions.Item label="¿Necesita Pilas?" span={2}>{detalle.necesita_pilas ? 'Sí' : 'No'}</Descriptions.Item>
      <Descriptions.Item label="Género" span={2}>{detalle.genero_juguete || '—'}</Descriptions.Item>
    </Descriptions>
  );
};

// Detalle para artículo Cosmético
export const CDetalleArticuloCosmetico = ({ detalle }) => {
  if (!detalle) return null;
  return (
    <Descriptions bordered column={2} size="small" style={{ marginTop: '2rem' }} labelStyle={{ width: '160px' }}>
      <Descriptions.Item label="Fragancia" span={2}>{detalle.fragancia || '—'}</Descriptions.Item>
      <Descriptions.Item label="Contenido Neto" span={2}>{detalle.contenido_neto || '—'}</Descriptions.Item>
      <Descriptions.Item label="Tipo de Piel" span={2}>{detalle.tipo_piel || '—'}</Descriptions.Item>
      <Descriptions.Item label="Uso" span={2}>{detalle.uso || '—'}</Descriptions.Item>
      <Descriptions.Item label="Género" span={2}>{detalle.genero || '—'}</Descriptions.Item>
    </Descriptions>
  );
};